import React from "react";
import AccountInfo from "../account/account-info";

const CheckoutCustomerInfo = ({ customerInfo, isGuest, updateCustomerData, customerData, isCheckoutPage, customerErrorInfo, updateCustomerErrorInfo }) => {
  return (
    <AccountInfo
      customerInfo={customerInfo}
      updateCustomerData={updateCustomerData}
      isGuest={isGuest}
      customerData={customerData}
      isCheckoutPage={isCheckoutPage}
      customerErrorInfo={customerErrorInfo}
      updateCustomerErrorInfo={updateCustomerErrorInfo}
    />
  );
};

export default CheckoutCustomerInfo;
